var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsite2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_8559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99781 18.3296C14.5993 18.3296 18.3296 14.5993 18.3296 9.99781C18.3296 5.39629 14.5993 1.66602 9.99781 1.66602C5.39629 1.66602 1.66602 5.39629 1.66602 9.99781C1.66602 14.5993 5.39629 18.3296 9.99781 18.3296Z",
    stroke: "#2B7FFF",
    strokeWidth: 1.66636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66504 9.99781C6.66504 6.89567 7.85835 3.91239 9.99776 1.66602C12.1372 3.91239 13.3305 6.89567 13.3305 9.99781C13.3305 13.0999 12.1372 16.0832 9.99776 18.3296C7.85835 16.0832 6.66504 13.0999 6.66504 9.99781Z",
    stroke: "#2B7FFF",
    strokeWidth: 1.66636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 9.99805H18.3296",
    stroke: "#2B7FFF",
    strokeWidth: 1.66636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_8559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9963,
    height: 19.9963,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite2);
export default __webpack_public_path__ + "static/media/website2.8ba876e11f3c5cb5a08dd11f344d63c9.svg";
export { ForwardRef as ReactComponent };